<template>
	<div class="myoutput-list" @mouseenter="changeActive(true)" @mouseleave="changeActive(false)" v-bind:class="{active:isActive }">
		<div class="myoutput-list-header">
			<span class="status-title">{{mark}}&nbsp;{{name}}</span>
			<span class="" v-on:click.prevent="selected=!selected">&nbsp;<i class="fa" v-bind:class="{'fa-minus-square-o':selected,'fa-plus-square-o':!selected}"></i></span>
			<span class="hovicon" @click="calcu();">计算</span>
			<span class="">{{error}}</span>
		</div>
		<div class="myoutput-list-body" v-show="selected">
			<div class="input-group input-group-sm" v-for="(item,index) in statusui.value">
				<span class="input-group-addon input-group-addon-color" style="">{{item.desc}}{{index}}&nbsp;<input class="" type="checkbox" v-model="item.checked"/></span>
				<div>
					<input class="form-control my-form-control" style="" type="number" :disabled="!item.checked" v-mynumber="{class:''}" :value="(value[index]*item.conversion).toFixed(2)"
						@input="value[index]=$event.target.value/item.conversion" :min="item.min" :max="item.max" :title="item.unit" :step="item.step"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	var common = require("../common.js");
	var core = require("../EHcore.js");
	export default {
		props: ['name', 'mark', 'value', 'atm'],
		data: function () {
			return {
				error: '',
				selected: false,
				isActive: false,
				statusui: this.val2UI(),
			}
		},
		methods: {
			calcu: function () {
				var chekedObj = this.getChecked();
				if (chekedObj.num == 2) {
					try {
						var res = eval("core.Calcu_" + chekedObj.ord + "(" + chekedObj.parms + "," + this.atm + ")");
						this.value.t = res.t == 'NaN' ? 0 : res.t;
						this.value.tw = res.tw == 'NaN' ? 0 : res.tw;
						this.value.td = res.td == 'NaN' ? 0 : res.td;
						this.value.h = res.h == 'NaN' ? 0 : res.h;
						this.value.d = res.d == 'NaN' ? 0 : res.d;
						this.value.rh = res.rh == 'NaN' ? 0 : res.rh;
						this.value.pv = res.pv == 'NaN' ? 0 : res.pv;
						this.error = "计算成功"
						this.timeClose(this);
					} catch (error) {
						this.error = "该方法未集成"
						this.timeClose(this);
					}
					
				} else {
					this.error = "选中2个参数即可"
					this.timeClose(this);
				}
				return false;//submit
			},

			val2UI: function () {
				var StatusTemplate = {
					desc: this.name || '当前状态点',
					mark: 'i',
					type: 'status',
					value: {
						t: { id: 0, unit: '℃', conversion: 1, step: 0.01, min: 0, max: 50, desc: '干球温度', checked: false },
						tw: { id: 1, unit: '℃', conversion: 1, step: 0.01, min: 0, max: 50, desc: '湿球温度', checked: false },
						rh: { id: 2, unit: '%', conversion: 1, step: 0.01, min: 0, max: 100, desc: '相对湿度', checked: false },
						td: { id: 3, unit: '℃', conversion: 1, step: 0.01, min: 0, max: 50, desc: '露点温度', checked: false },
						d: { id: 4, unit: 'g/kga', conversion: 1000, step: 0.01, min: 0, max: 45, desc: '含湿量', checked: false },
						h: { id: 5, unit: 'kJ/kga', conversion: 1, step: 0.01, min: -10, max: 150, desc: '焓值', checked: false },
						pv: { id: 6, unit: 'kPa', conversion: 1, step: 0.01, min: -10, max: 150, desc: '分压力', checked: false }
					}
				}
				StatusTemplate.value.t.value = this.value.t;
				StatusTemplate.value.tw.value = this.value.tw;
				StatusTemplate.value.rh.value = this.value.rh;
				StatusTemplate.value.td.value = this.value.td;
				StatusTemplate.value.d.value = this.value.d;
				StatusTemplate.value.h.value = this.value.h;
				StatusTemplate.value.pv.value = this.value.pv;
				return StatusTemplate
			},
			getChecked: function () {
				var point = this.statusui.value;
				var num = 0, ord = '', parms = '';
				for (var item in point) {
					//不使用过滤
					if (point[item].checked) {
						ord = ord + point[item].id;
						parms = parms + ',' + this.value[item];
						num++;
					}
				}
				parms = parms.substr(1);
				return {
					num: num,
					ord: ord,
					parms: parms
				};
			},
			//定时关闭错误，这个需要用引用类型
			timeClose: function (obj) {
				setTimeout(function () {
					obj.error = '';
				}, 3000)
			},
			changeActive: function (active) {
				this.isActive = active
				this.value.isActive = active;
				var event = { isActive: active, mark: this.mark, value: common.deepCopy(this.value) }//这儿如果用deepcopy可以避免curStatusData引用之前的值
				this.$emit('changeactive', event)
			}
		}
	}

</script>

<style>

</style>


// WEBPACK FOOTER //
// status.vue?6f0453f4